import React from 'react'
import styles from './style'
import propTypes from './prop'
import ComponentBoxContent from '../../../model/component-box'
import { withStyles, Grid } from '@material-ui/core'
import {
  componentBoxHideAction,
  componentBoxShowAction,
} from '../../../reducers/component-box/action'
import { CoreButton } from 'src/components/core'
import { Icon } from '@iconify/react'

const TeamEmpty = props => {
  const {
    classes,
    onAdd,
    dispatch,
    addItemButtonLabel,
    componentBoxContent,
  } = props

  /**
   *
   * @param {*} e
   */
  const onAddClick = e => {
    /**
     *
     */
    const onCancel = () => {
      dispatch(componentBoxHideAction())
    }

    /**
     *
     * @param {*} list
     */
    const onOk = (idlist, entityList) => {
      onCancel()

      onAdd(entityList)
    }

    dispatch(
      componentBoxShowAction(
        new ComponentBoxContent(componentBoxContent(onOk, onCancel), {
          hideCloseButton: true,
        }),
      ),
    )
  }

  return (
    <Grid container>
      <CoreButton
        onClick={onAddClick}
        variant="text"
        color="primary"
        size="small"
        startIcon={<Icon icon="ic:round-add" />}
      >
        {addItemButtonLabel}
      </CoreButton>
    </Grid>
  )
}

TeamEmpty.propTypes = propTypes

export default withStyles(styles)(TeamEmpty)
